import { Link, useNavigate } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { toast } from "react-toastify";
import { STATUS } from "../../constant";
import React, { Fragment, useEffect, useState } from "react";
import { fetchProfileReset } from "../../store/actions";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  passwordChangeReset,
  passwordChangeRequest,
} from "../../store/actions";
import GlobalStyles from "@mui/joy/GlobalStyles";
import Sheet from "@mui/joy/Sheet";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import IconButton from "@mui/joy/IconButton";
import Avatar from "@mui/joy/Avatar";
import Tooltip from "@mui/joy/Tooltip";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import ListDivider from "@mui/joy/ListDivider";

import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { toggleSidebar } from "../../utils/sideBarutils";
import { logoutRequest, resetUserType, resetAppState, notificationsRequest } from "../../store/actions";
import { useColorScheme } from "@mui/joy/styles";
import { NAVIGATE_TO_DASHBOARD, NAVIGATE_TO_LOGINPAGE, NAVIGATE_TO_NOTIFICATIONPAGE, NAVIGATE_TO_PROFILEPAGE } from "../../route/types";
import image from "../../constant/image";
import { Lock, NotificationsRounded } from "@mui/icons-material";
import {
  Badge,
  Button,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
} from "@mui/joy";
// import ColorSchemeToggle from '../../utils/ColorSchemeToggle';

function ColorSchemeToggle() {
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return <IconButton size="sm" variant="outlined" color="primary" />;
  }
  return (
    <Tooltip title="Change theme" variant="outlined">
      <IconButton
        id="toggle-mode"
        size="sm"
        variant="plain"
        color="neutral"
        sx={{ alignSelf: "center" }}
        onClick={() => {
          if (mode === "light") {
            setMode("dark");
          } else {
            setMode("light");
          }
        }}>
        {mode === "light" ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
      </IconButton>
    </Tooltip>
  );
}

const Header = ({
  loginResult
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userData, setUserData] = useState({
    name: "",
    email: "",

  })

  const logOut = () => {
    // navigate(NAVIGATE_TO_LOGINPAGE)
    // setTimeout(() => {
    //   dispatch(resetUserType());
    // }, 2000);
    dispatch(logoutRequest());
    dispatch(resetAppState())
  };

  useEffect(() => {
    if (loginResult) {
      setUserData({
        name: `${loginResult.first_name}  ${loginResult.last_name}`,
        email: loginResult.email
      })
    }
  }, [])

  return (
    <Fragment>
      <Sheet
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          backgroundColor: 'background.body',
          top: 0,
          width: "100vw",
          // bgcolor: "background.appcolor",
          // height: 'var(--Header-height)',
          zIndex: 9995,
          px: { xs: 1, md: 3 },
          py: { xs: 2, md: 2 },
          gap: 1,
          borderBottom: "1px solid",
          borderColor: "background.level1",
          boxShadow: "sm",
        }}>
        <GlobalStyles
          styles={(theme) => ({
            ":root": {
              "--Header-height": "52px",
              [theme.breakpoints.up("md")]: {
                "--Header-height": "0px",
              },
            },
          })}
        />
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            transform: {
              md: "translateX(calc(100% * (var(--SideNavigation-slideIn, 1) - 1)))",
            },
            // borderColor: "background",
            ml: { lg: 'var(--SideNavigation-open)' },
            alignItems: 'center'

          }}>
          {/* toggle sidebar button */}
          <IconButton
            onClick={() => toggleSidebar()}
            variant="outlined"
            // color="neutral"
            size="sm"
            sx={{
              transform: {
                md: "translateX(calc(100% * (var(--SideNavigation-slideIn, 1) - 1)))",
              },
              // borderColor: "background",
              // ml: { lg: 'var(--SideNavigation-open)' }
            }}>
            <MenuIcon />
          </IconButton>

          {/* web name */}
          <Link to={NAVIGATE_TO_DASHBOARD} style={{ textDecoration: 'none' }}>
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1, alignItems: "center" }}>
              <Typography level="title-lg">OPEN PESA PORTAL</Typography>
              {/* <ColorSchemeToggle sx={{ ml: 'auto' }} /> */}
            </Box>
          </Link>
        </Box>



        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
            alignItems: "center",
          }}>

          {/* Change theme */}
          <ColorSchemeToggle />

          {loginResult.role === 1 &&
            <Tooltip title='notifications' variant="outlined">
              <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                sx={{ alignSelf: "center" }}
                onClick={() => {
                  navigate(NAVIGATE_TO_NOTIFICATIONPAGE);
                }}>
                {<Badge badgeContent={0} max={99} size="sm" sx={{ color: 'background.secondaryColor' }}>
                  <NotificationsRounded />
                </Badge>}
              </IconButton>
            </Tooltip>}

          {/* Profile */}
          <Dropdown>
            <MenuButton
              variant="plain"
              size="sm"
              sx={{
                // maxWidth: "32px",
                gap: 1,
                maxHeight: "32px",
                borderRadius: "9999999px",
              }}>
              <Avatar
                src={image.Images.userIcon}
                sx={{ maxWidth: "29px", maxHeight: "29px" }}
                size="sm"
              />
              <Typography level="title-sm" sx={{ display: { xs: 'none', md: 'flex' } }}>
                {userData.name}
              </Typography>

            </MenuButton>
            <Menu
              placement="bottom-end"
              size="sm"
              sx={{
                zIndex: "99999",
                p: 1,
                gap: 1,
                "--ListItem-radius": "var(--joy-radius-sm)",
              }}>
              <MenuItem >
                <Link to={NAVIGATE_TO_PROFILEPAGE} style={{ textDecoration: 'none' }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Avatar
                      src={image.Images.userIcon}
                      sx={{ maxWidth: "29px", maxHeight: "29px" }}
                      size="sm"
                    />
                    <Box sx={{ ml: 1.5 }}>
                      <Typography level="title-sm">
                        {userData.name}
                      </Typography>
                      <Typography level="body-sm">
                        {userData.email}
                      </Typography>
                    </Box>
                  </Box>
                </Link>
              </MenuItem>

              <Divider />

              <MenuItem component="a" href="#" onClick={logOut}>
                <LogoutRoundedIcon />
                Log out
              </MenuItem>
            </Menu>
          </Dropdown>
        </Box>
      </Sheet>
    </Fragment>
  );
};

//mapping Redux store states to props
const mapStateToProps = ({ auth }) => {
  const {
    otpResult: loginResult,

    notificationStatus: notificationStatus,
    notificationResult: notificationResult
  } = auth;

  return {
    loginResult,

    notificationStatus,
    notificationResult
  };
};

export default connect(mapStateToProps, {})(Header);
// export default Header
